export default {
  title: 'Promo codes work in your digital experiences today',
  body: 'In-store redemption for Toast locations is coming soon. For now, codes apply to online and app orders only.',
}
